export const titular = [
    {
       "nombre" : "Mtro. Francisco Martínez Gómez",
       //"imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/veda/titular_veda.png",
       "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Ligas/FMG.png",
       "funcion" : "La persona titular de la Dirección General, administrará y representará legalmente al organismo, llevando a cabo trámites y atención oportuna de los asuntos que son de su competencia. Para tal efecto, contará con las facultades y obligaciones enmarcadas en la Ley, el Reglamento, y las conferidas en su propio Decreto de Creación."
    }
]